"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketCorsInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketCorsInput.js.map